// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Constants
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

const DEWEY_MESSAGE_PREFIX = 'dewey--';

const DeweyMessages = {
  // Internal
  REQUEST_CENTER_FRAME: 'request-center-frame',
  REQUEST_FULLSCREEN: 'request-fullscreen',
  CANCEL_FULLSCREEN: 'cancel-fullscreen',
  REQUEST_WINDOW_UPDATE: 'request-window-update',
  CHAT_STARTED: 'chat-started',
  BROADCAST_EVENT: 'broadcast-event'
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Methods
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// Core Message Passing

export function postMessage(message) {
  window.parent.postMessage(`${DEWEY_MESSAGE_PREFIX}${message}`, '*');
}

export function postMessageData(messageData, messageType) {
  window.parent.postMessage({
    ...messageData,
    message: `${DEWEY_MESSAGE_PREFIX}${messageType}`
  }, '*');
}

// Individual Message Types

export function postRequestCenterFrame() {
  postMessage(DeweyMessages.REQUEST_CENTER_FRAME);
};

export function postRequestFullscreen() {
  postMessage(DeweyMessages.REQUEST_FULLSCREEN);
}

export function postCancelFullscreen() {
  postMessage(DeweyMessages.CANCEL_FULLSCREEN);
}

export function postRequestWindowUpdate() {
  postMessage(DeweyMessages.REQUEST_WINDOW_UPDATE);
}

export function postChatStarted() {
  postMessage(DeweyMessages.CHAT_STARTED);
}

export function postBroadcastEvent(event, eventDetail) {
  postMessageData({
    ...eventDetail,
    event,
  }, DeweyMessages.BROADCAST_EVENT);
}
